<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="receiptList_search_button" @click="funcFilter()">
          查询
        </el-button>
        <el-button v-if="receiptList_export_button" @click="funcExport()">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      :loading="loading"
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="100" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="documentNumber"
          title="单据号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.documentNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentPhone"
          title="手机号码"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="结算方式"
          :formatter="formatterPayType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="bankName"
          title="本单位银行"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankAccount"
          title="本单位账号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankAccount"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="feeType"
          title="款项类型"
          :formatter="formatterFeeType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.feeType" clearable placeholder="请选择">
            <el-option
              v-for="item in feeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="交款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payAmountUpper"
          title="大写"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payAmountUpper"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="payAmount" title="金额" width="200" sortable />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.payAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('payAmountMin')"
            />
            <el-input
              v-model="listQuery.payAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('payAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.authStatus" clearable placeholder="请选择">
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="payDate"
          title="单据日期"
          width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.payDateRange"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="value => changeDate(value, 'payDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="创建人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import { collectionPost } from "@/api/category";
import { isNumber } from "@/utils/validate.js";
export default {
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-tms-api/collectionAccountCheck/exportCollectionReceipt", //导出接口
        name: "收款列表"
      },
      message: "",
      loading: false,
      receiptList_search_button: false, //查询
      receiptList_export_button: false, //导出
      tableData: [],

      listQuery: {
        payDateRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        collectionAccountionType: 2
      },
      options: [
        {
          value: "0",
          label: "转账"
        },
        {
          value: "1",
          label: "承兑汇票"
        }
      ],
      feeTypeOptions: [
        {
          value: "0",
          label: "应收款"
        }
      ],
      authStatusOptions: [
        {
          value: "0",
          label: "未审核"
        },
        {
          value: "1",
          label: "审核中"
        },
        {
          value: "2",
          label: "审核不通过"
        },
        {
          value: "3",
          label: "已扣补"
        }
      ],
      sumObject: {},
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
    this.receiptList_search_button = getLimit("receiptList_search_button");
    this.receiptList_export_button = getLimit("receiptList_export_button");
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        collectionPost(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },

    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "payAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    formatterPayType({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "转账";
        case 1:
          return "承兑汇票";
      }
    },
    formatterFeeType({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "应收款";
        case 1:
          return "";
      }
    },
    formatterAuthStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未审核";
        case 1:
          return "审核中";
        case 2:
          return "审核不通过";
        case 3:
          return "已扣补";
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style></style>
